import { render, staticRenderFns } from "./MonsterHome.vue?vue&type=template&id=16975c30"
import script from "./MonsterHome.vue?vue&type=script&lang=js"
export * from "./MonsterHome.vue?vue&type=script&lang=js"
import style0 from "./MonsterHome.vue?vue&type=style&index=0&id=16975c30&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16975c30')) {
      api.createRecord('16975c30', component.options)
    } else {
      api.reload('16975c30', component.options)
    }
    module.hot.accept("./MonsterHome.vue?vue&type=template&id=16975c30", function () {
      api.rerender('16975c30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/monster/MonsterHome.vue"
export default component.exports